import { createContext, ReactElement, useContext } from "react";
import GetEventsCheckin, { ResponseMembrosCheckin } from "../services/getEventsCheckin";


export const ServicesEventosContext = createContext<ResponseMembrosCheckin>(null);


export const ProviderServicesEventosCheckin = ({children}: { children: ReactElement | ReactElement[] }) => {

  const services = GetEventsCheckin();

  return (
    <ServicesEventosContext.Provider value={services}>
      {children}
    </ServicesEventosContext.Provider>
  )
}


export const useServicesEventosCheckin = () => {
  const context = useContext(ServicesEventosContext);
  return context;
}
